export default __webpack_public_path__ + "static/7-25e05fd7c27b5b921e7f01ba6a25e5f0.jpg";